import React from 'react';
import PropTypes from 'prop-types';
import css from './DropdownOptionLabel.css';

const DropdownOptionLabel = ({ value, label }) => (
    <span className={css.dropdownOption}>
        <code className={css.dropdownSingularKey}>{value}</code>
        <span>{label}</span>
    </span>
);

DropdownOptionLabel.propTypes = {
    value: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
};

export default DropdownOptionLabel;
